export default "__VITE_ASSET__D1lU$S$o__"